module.exports = __webpack_public_path__ + "img/m3_t2_bg.aaf864ce.svg";